import { defineAsyncComponent } from 'vue'
export default {
  "mobile-app": defineAsyncComponent(() => import("/src/app/layouts/mobile-app/MobileApp.vue").then(m => m.default || m)),
  "mobile-app-css": defineAsyncComponent(() => import("/src/app/layouts/mobile-app/css.ts").then(m => m.default || m)),
  "web-responsive": defineAsyncComponent(() => import("/src/app/layouts/web-responsive/WebResponsive.vue").then(m => m.default || m)),
  "web-responsive-css": defineAsyncComponent(() => import("/src/app/layouts/web-responsive/css.ts").then(m => m.default || m))
}